import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { Box } from "@mui/material";
import { PostAction, postData } from "../api/AuthenticatedApiCaller";
import { SiteSettingsApi } from "../api/AdminApi";
import OperationResult from "../commons/OperationResult";

export default function SiteSettingAddDialog(props) {
  const [hasError, setHasError] = useState(null);

  const updatedSetting = JSON.parse(JSON.stringify(props.setting));

  async function save() {
    let [data, error] = await postData(SiteSettingsApi.updateSiteSettings, updatedSetting);
    if (!error) {
      setHasError(false)
    } else {
      setHasError(true)
    }
    props.save()
  }

  return (
    <Box>
      {hasError !== null && <OperationResult success={!hasError} />}

      <Dialog open={props.open}>
        <DialogTitle>Edit {props.setting.name}</DialogTitle>
        <DialogContent>
          <Stack
            sx={{ width: "100%", height: "100%" }}
            component="paper"
            spacing={4}
          >
            {updatedSetting.contents.map((content) => (
              <TextField
                defaultValue={content.text}
                label={content.language}
                onChange={(event) => {
                  content.text = event.target.value;
                }}
              />
            ))}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={save}
          >
            Save
          </Button>
          <Button onClick={props.cancel} autoFocus>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
